export default "__VITE_ASSET__Dy92qGL3__"